import { render, staticRenderFns } from "./LeaveReset.vue?vue&type=template&id=77671220"
import script from "./LeaveReset.vue?vue&type=script&lang=js"
export * from "./LeaveReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports